import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  // Set JSON content-type by default UNLESS sending FormData
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";
  } else {
    delete config.headers["Content-Type"]; // let browser set with boundary
  }
  // Use portal token only on /portal/* routes
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const isPortal = path.startsWith("/portal");
  const token = localStorage.getItem(isPortal ? "crm_portal_token" : "crm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      const isPortal = path.startsWith("/portal");
      const loginPath = isPortal ? "/portal/login" : "/login";
      if (path !== loginPath) {
        localStorage.removeItem(isPortal ? "crm_portal_token" : "crm_token");
        window.location.href = loginPath;
      }
    }
    return Promise.reject(err);
  }
);

export default apiClient;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return JSON.stringify(detail);
}

export function authedFileUrl(fileId) {
  const token = localStorage.getItem(window.location.pathname.startsWith("/portal") ? "crm_portal_token" : "crm_token");
  return `${API}/files/${fileId}/download?auth=${encodeURIComponent(token || "")}`;
}
